import { combineReducers } from "redux";
import commonOnePlatFormReducer from "@frameworks/web/redux/reducers/common/commonReducer";
import { CONTRACT_COMMODITY, } from "@frameworks/web/redux/interfaces/Reports/iContractCommodity";
const initState = {
    contractCommodity: [],
};
const ContractCommodityReducer = (state = initState, action) => {
    switch (action.type) {
        case CONTRACT_COMMODITY:
            return Object.assign(Object.assign({}, state), { contractCommodity: action.payload.contractCommodity });
        default:
            return Object.assign({}, state);
    }
};
export default combineReducers({
    reducersData: ContractCommodityReducer,
    commonData: commonOnePlatFormReducer,
});
